<template>
  <div id="shop">
    <HoriTitle :firstTitle="'内衣商城'" :secondTitle="'UNDERWEAR MALL'" />
    <Gallery :list="shop.list" />
    <Pagination
      :total="shop.total"
      v-on:curPageChange="updatePage"/>
  </div>
</template>

<script>
  import HoriTitle from '@/components/HoriTitle'
  import Gallery from '@/components/Gallery'
  import Pagination from '@/components/Pagination'
  import gql from '@/graphql/graphql'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      Gallery,
      Pagination,
      HoriTitle
    },
    asyncData ({ store, route }) {
      const page = route.params.page ? route.params.page : 1;
      store.state.params.variables.page = page;

      const param = { ...store.state.params };
      param.variables.type = store.state.contentType[1];
      param.query = gql.GET_WEB_SHOP_LIST;

      return store.dispatch('getShopList', param)
    },
    provide () {  // 依赖注入传值
      return {
        type: 'commodity'
      }
    },
    computed: {
      ...mapGetters({
        shop: 'shopData'
      })
    },
    methods: {
      updatePage (page) {
        window.location.href = `/shop/p-${page}.html`

      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  #shop {
    width: 980px;
    margin: 0 auto;
    padding: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Shop.vue